module.exports = __webpack_public_path__ + "static/media/telegram_sm.cccb266a947fcfa39f216dc79a1b25da.svg";